export { default } from './ForgotPassword';
